export enum EEndConditionTypes {
    EXERCISE_END_CONDITION_DURATION = 'exercise_end_condition_duration',
    EXERCISE_END_CONDITION_GOAL = 'exercise_end_condition_goal',
    EXERCISE_END_CONDITION_LAST_MAN_STANDING = 'exercise_end_condition_last_man_standing',
    EXERCISE_END_CONDITION_RACE = 'exercise_end_condition_race',
    EXERCISE_END_CONDITION_TRASH_TALK = 'exercise_end_condition_trash_talk',
    EXERCISE_END_CONDITION_SMASH = 'exercise_end_condition_smash',
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/config/EEndConditionTypes.ts